import { ApiResponse } from '@/modules/common';
import { axiosInstance } from '@/utils/axios';

import { mapOrganizationIntegrationStatusApiResponseFromDTO } from '../mappers/integration-status.mapper';
import { OrganizationIntegrationStatusApiResponse } from '../types/dto/response/integration-status-response';
import { OrganizationIntegrationStatusData } from '../types/integration-status';

/**
 * Fetches the integration status for the organization
 * Returns status of all connected integrations including sync state and errors
 */
export const getIntegrationStatus = async (): Promise<OrganizationIntegrationStatusData> => {
  const response = await axiosInstance.get<ApiResponse<OrganizationIntegrationStatusApiResponse>>(
    '/api/integrations/status'
  );

  if (response.data.error) {
    throw new Error(response.data.error.message);
  }

  // Map API response to domain model
  return mapOrganizationIntegrationStatusApiResponseFromDTO(response.data.data);
};
